/* ==========================================================================
   NAV — open the mega menus on hover.                 Added 2026-08-24.

   Owner: "also want the menu items to open on hover."

   Dawn builds these as <details> inside a <header-menu> custom element, which
   is click-and-keyboard by nature. This adds hover WITHOUT taking anything
   away: clicking still toggles, Escape still closes, tab/enter still work.
   Setting `.open` fires the native `toggle` event, which is what HeaderMenu
   already listens for — so its animation and header-position bookkeeping run
   exactly as they do on a click. Nothing in details-disclosure.js is touched.

   Guarded on a real pointer. On a touch screen `mouseenter` fires on the tap
   that was meant to follow the link, so a hover-open menu on a phone opens and
   closes under the user's finger. Dawn hides this nav below 990px anyway; the
   media query is belt and braces for a touch laptop.

   To revert: drop this file and its <script> in sections/header.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var OPEN_DELAY = 60;    /* long enough that a cursor crossing the bar on its
                             way somewhere else does not flash three menus */
  var CLOSE_DELAY = 220;  /* long enough to travel the diagonal gap between the
                             item and the panel below it without it shutting */

  function init() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;

    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var menus = [].slice.call(nav.querySelectorAll('header-menu'));
    if (!menus.length) return;

    var openTimer = null;
    var closeTimer = null;

    function setOpen(hm, open) {
      var d = hm.querySelector('details');
      if (!d || d.open === open) return;
      d.open = open;
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeAll(except) {
      menus.forEach(function (hm) { if (hm !== except) setOpen(hm, false); });
    }

    menus.forEach(function (hm) {
      hm.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () {
          closeAll(hm);
          setOpen(hm, true);
        }, OPEN_DELAY);
      });

      hm.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { setOpen(hm, false); }, CLOSE_DELAY);
      });

      /* A click on a menu that hover already opened would toggle it shut, which
         reads as the menu refusing to open. Swallow that one case only —
         a click on a CLOSED menu still opens it, so nothing is lost for anyone
         driving this by click or by keyboard. */
      var summary = hm.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          var d = hm.querySelector('details');
          if (d && d.open && hm.matches(':hover')) e.preventDefault();
        });
      }
    });

    /* Leaving the bar entirely closes whatever is open. Without this a menu
       opened by hover stays open until something else is hovered. */
    nav.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { closeAll(null); }, CLOSE_DELAY);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
